//@ts-ignore
import anime from 'animejs/lib/anime.es.js'
import Merge from 'lodash/merge'
import INikanAnimation, { INikanAnimationOptions } from '~/interfaces/plugins/anime'

class NikanAnimation implements INikanAnimation {

  private instance: any
  private baseMessage: string = '[Nikan Animation]'

  targets: any
  path: string | undefined

  options: INikanAnimationOptions = {
    autoplay: false
  }

  constructor(targets: any, options: INikanAnimationOptions, path?: string) {
    this.targets = targets
    this.options = Merge(this.options, options)
    this.path = path
    this.createInstance()
  }

  createInstance(): void {
    const mergedOptions = Merge({ targets: this.targets }, this.options)
    this.instance = anime(mergedOptions)
  }

  returnInsntace(): object {
    return this.instance
  }

  seek(timeStamp: number): void {
    this.instance.seek(timeStamp)
  }

  reverse(): void {
    this.instance.reverse()
  }

  restart(): void {
    this.instance.restart()
  }

  stop(): void {
    if (this.options.autoplay)
      throw new Error(`${this.baseMessage} Autoplay must be off!`)

    this.instance.stop()
  }

  play(): void {
    if (this.options.autoplay)
      throw new Error(`${this.baseMessage} Autoplay must be off!`)

    this.instance.play()
  }

  remove(targets: any): void {
    this.instance.remove(targets)
  }

  get(target: string, propertyName: string, unit: string): object {
    return this.instance.get(target, propertyName, unit)
  }

  set(targets: any, options: object): void {
    this.instance.set(targets, options)
  }

  running(): object[] {
    return this.instance.running
  }

  update(instance: object = this.instance): any {
    this.instance.update()
  }
}

export default NikanAnimation
